/**
 * HydraCanvasNode
 *
 * Output node for Hydra chains — the hydra endpoint on hydraOut
 * is where HydraRenderers are created when connected to video nodes.
 * With graph-query mode, the renderer walks upstream from this node.
 */

import type { NodeDef } from '@runtime/IRuntime';
import { internals } from '@/nodes/TypedEndpoints';
import { HydraBaseNode } from './HydraBaseNode';

const endpoints = {
  ...internals({
    videoIn: { order: 1, isInput: true, dataType: 'video' },
    hydraOut: { order: 2, isOutput: true, dataType: 'hydra' }
  })
};

class HydraCanvasNode extends HydraBaseNode<typeof endpoints> {
  // Chain is now built by HydraRenderer via graph query — no propagation needed
}

export const hydraCanvasNodeDef: NodeDef<HydraCanvasNode> = {
  type: 'Canvas',
  shortName: 'canvas',
  info: 'Output node for Hydra shader chains. Renderers are created when connected to video nodes.',
  category: 'output',
  endpoints,
  ctor: HydraCanvasNode
};
